<template>
  <div id="app">
    <navbar ></navbar>
    <div class="wrapper">
      <!-- 把要傳到子component的資料綁上去 -->
      <router-view :cosmoUrl="baseUrl" :allProductData="productData" :allProcuctClass="productClass" :screenWidth="screenWidth"></router-view>
    </div>
    <btnGoTop></btnGoTop>
   
  </div>
 
</template>

<script>
import Navbar from './components/Navbar'
import btnGoTop from './components/btnGoTop'
import axios from 'axios'
export default {
  name: 'app',
  components: {
    Navbar,
    btnGoTop
  },
  data(){
    return{
      screenWidth: document.body.clientWidth,
      baseUrl: 'http://event.cosmopolitan.com.tw/2017/beautyawards/',
      // baseUrl:'http://c.hearst-taiwan.com.tw/2017/beautyawards/',
      productData:{},
      productClass:{
        1:{
          engName: "Base",
          chiName: "底妝"
        },
        2:{
          engName: "Cushion",
          chiName: "氣墊粉餅"
        },
        3:{
          engName: "Primer",
          chiName: "妝前飾底"
        },
        4:{
          engName: "Eye",
          chiName: "眼妝"
        },
        5:{
          engName: "Lip",
          chiName: "唇彩"
        },
        6:{
          engName: "Blusher",
          chiName: "腮紅"
        },
        7:{
          engName: "Cleanse",
          chiName: "卸妝洗臉"
        },
        8:{
          engName:"Moisturizer",
          chiName:"保溼"
        },
        9:{
          engName:"Whitening",
          chiName:"美白"
        },
        10:{
          engName:"Anti aging",
          chiName:"抗老"
        },
        11:{
          engName:"Suncreen",
          chiName:"防曬"
        },
        12:{
          engName:"Mask",
          chiName:"面膜"
        },
        13:{
          engName:"Bady Care",
          chiName:"身體保養"
        },
        14:{
          engName:"Fragrance",
          chiName:"香氛"
        },
        15:{
          engName:"Hair Care",
          chiName:"頭髮保養"
        },
        16:{
          engName:"Beauty Device",
          chiName:"美容儀器"
        }

      }
    }
  },
  mounted (){
    
    
  },
  created () {
      const self = this
      const productUrl = self.baseUrl+'route.php?r=item'
      axios.get(productUrl)
      .then((resp) => {
        self.productData = resp.data
        // console.log("app.vue-----")
        // console.log(self.productData)

        let href = this.$route.path
        if(href=="/")
        {
          this.$router.push({path: '/Top10'})
        }

        window.onresize = () => {
          return (() => {
              window.screenWidth = document.body.clientWidth
              self.screenWidth = window.screenWidth
          })()
        }

      // this.handleResize()

      
      })
      .catch((err) => {
        console.log(err)
      })

     
  },
  destroyed () {
 
  },
  watch: {
      screenWidth (val) {
          if (!this.timer) {
            this.screenWidth = val
            this.timer = true
            let self = this
            setTimeout(function () {
                // self.screenWidth = self.$store.state.canvasWidth
                // console.log(self.screenWidth)
                // self.init()
                self.timer = false
                // self.handleResize()
            }, 400)
        }
      }
  },
  methods:{
    // handleResize(event){
    //     console.log("w:"+screenWidth)
    //     if(screenWidth>1200)
    //     {
    //       this.$router.push(
    //         {
    //           path: '/Top10'
    //         }
    //       )
    //     }else{
    //       this.$router.push(
    //         {
    //           path: '/m-Top10'
    //         }
    //       )
    //     }
    // }
  }
}

</script>

<style lang="scss">
// @import "~bootstrap/dist/css/bootstrap.css";
// .navbar-light .navbar-nav .router-link-active{
//   color: green
// }
</style>



// WEBPACK FOOTER //
// App.vue?28026f62